
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';

createRoot(document.getElementById("root")!).render(<App />);

// Register the service worker in production
// In development, we can use unregister() instead to avoid caching issues
if (import.meta.env.PROD) {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}
